import React from 'react';
import icon from '../../../images/flowdo-icon.png';
import './FlowdoLoader.css';

export default function FlowdoLoader({
  label = 'Loading…',
  size = 'md',
  className = '',
}) {
  const sizeClass = size === 'sm' ? 'flowdo-loader--sm' : size === 'lg' ? 'flowdo-loader--lg' : '';
  const statusClass = ['flowdo-loader-status', className].filter(Boolean).join(' ');

  return (
    <div className={statusClass} role="status" aria-live="polite" aria-busy="true">
      <div className={`flowdo-loader ${sizeClass}`.trim()}>
        <div className="flowdo-loader-ring" aria-hidden="true" />
        <div className="flowdo-loader-ring flowdo-loader-ring--inner" aria-hidden="true" />
        <img src={icon} alt="" className="flowdo-loader-icon" />
      </div>
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
